import { createAction, props } from '@ngrx/store';
import { User } from '../../models/user';

export const getUser = createAction('[User] Get User');
export const getUserSuccess = createAction('[User] Get User success', props<{ user: any }>());
export const getUserFailure = createAction('[User] Get User failure', props<{ error: any }>());

export const loadUsers = createAction('[User] Load Users ', props<{ organizationId: string }>());
export const loadUsersSuccess = createAction('[User] Load Users success', props<{ users: User[] }>());
export const loadUsersFailure = createAction('[User] Load Users failure', props<{ error: any }>());
